import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CreateCourseDraft201,
  CreateCourseDraft400,
  CreateCourseDraft401,
  CreateCourseDraft403,
  CreateCourseDraft413,
  CreateCourseDraft415,
  CreateCourseDraftBody,
  DeleteCourseDraft401,
  DeleteCourseDraft403,
  DeleteCourseDraft404,
  GetCourseDraftAssets200,
  GetCourseDraftAssets401,
  GetCourseDraftAssets403,
  GetCourseDraftAssets404,
  GetCourseDraftAssets413,
  GetCourseDraftAssets415,
  GetCourseDraftAssetsParams,
  GetCourseDraftById200,
  GetCourseDraftById401,
  GetCourseDraftById403,
  GetCourseDraftById404,
  GetCourseDraftCount200,
  GetCourseDraftCount401,
  GetCourseDraftCount403,
  GetCourseDraftCountParams,
  GetCourseDrafts200,
  GetCourseDrafts401,
  GetCourseDrafts403,
  GetCourseDraftsParams,
  PublishCourseDraft200,
  PublishCourseDraft401,
  PublishCourseDraft403,
  PublishCourseDraft404,
  PublishCourseDraft409,
  UpdateCourseDraft200,
  UpdateCourseDraft400,
  UpdateCourseDraft401,
  UpdateCourseDraft403,
  UpdateCourseDraft404,
  UpdateCourseDraftBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 사용자의 코스 초안 목록을 페이징으로 조회합니다.
`filter=my_drafts` 파라미터로 현재 로그인한 사용자의 초안만 필터링할 수 있습니다.

 * @summary 코스 초안 목록 조회
 */
export const getCourseDrafts = (
    params?: GetCourseDraftsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCourseDrafts200>(
      {url: `https://api.ugot.uk/api/courses/drafts`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCourseDraftsQueryKey = (params?: GetCourseDraftsParams,) => {
    return [`https://api.ugot.uk/api/courses/drafts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCourseDraftsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDrafts>>, TError = GetCourseDrafts401 | GetCourseDrafts403>(params?: GetCourseDraftsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDrafts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDraftsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDrafts>>> = ({ signal }) => getCourseDrafts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDrafts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDraftsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDrafts>>>
export type GetCourseDraftsInfiniteQueryError = GetCourseDrafts401 | GetCourseDrafts403

/**
 * @summary 코스 초안 목록 조회
 */
export const useGetCourseDraftsInfinite = <TData = Awaited<ReturnType<typeof getCourseDrafts>>, TError = GetCourseDrafts401 | GetCourseDrafts403>(
 params?: GetCourseDraftsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDrafts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDraftsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCourseDraftsQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDrafts>>, TError = GetCourseDrafts401 | GetCourseDrafts403>(params?: GetCourseDraftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDrafts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDraftsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDrafts>>> = ({ signal }) => getCourseDrafts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseDrafts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDrafts>>>
export type GetCourseDraftsQueryError = GetCourseDrafts401 | GetCourseDrafts403

/**
 * @summary 코스 초안 목록 조회
 */
export const useGetCourseDrafts = <TData = Awaited<ReturnType<typeof getCourseDrafts>>, TError = GetCourseDrafts401 | GetCourseDrafts403>(
 params?: GetCourseDraftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDrafts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDraftsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 새로운 코스 초안을 생성합니다.
생성된 초안은 현재 로그인한 사용자가 강사로 설정됩니다.

 * @summary 새 코스 초안 생성
 */
export const createCourseDraft = (
    createCourseDraftBody: CreateCourseDraftBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      const formData = new FormData();
formData.append('data', createCourseDraftBody.data)
if(createCourseDraftBody.thumbnail !== undefined) {
 formData.append('thumbnail', createCourseDraftBody.thumbnail)
 }

      return customInstance<CreateCourseDraft201>(
      {url: `https://api.ugot.uk/api/courses/drafts`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getCreateCourseDraftMutationOptions = <TError = CreateCourseDraft400 | CreateCourseDraft401 | CreateCourseDraft403 | CreateCourseDraft413 | CreateCourseDraft415,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseDraft>>, TError,{data: CreateCourseDraftBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCourseDraft>>, TError,{data: CreateCourseDraftBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCourseDraft>>, {data: CreateCourseDraftBody}> = (props) => {
          const {data} = props ?? {};

          return  createCourseDraft(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCourseDraftMutationResult = NonNullable<Awaited<ReturnType<typeof createCourseDraft>>>
    export type CreateCourseDraftMutationBody = CreateCourseDraftBody
    export type CreateCourseDraftMutationError = CreateCourseDraft400 | CreateCourseDraft401 | CreateCourseDraft403 | CreateCourseDraft413 | CreateCourseDraft415

    /**
 * @summary 새 코스 초안 생성
 */
export const useCreateCourseDraft = <TError = CreateCourseDraft400 | CreateCourseDraft401 | CreateCourseDraft403 | CreateCourseDraft413 | CreateCourseDraft415,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseDraft>>, TError,{data: CreateCourseDraftBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createCourseDraft>>,
        TError,
        {data: CreateCourseDraftBody},
        TContext
      > => {

      const mutationOptions = getCreateCourseDraftMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * ID로 특정 코스 초안의 상세 정보를 조회합니다.
 * @summary 특정 코스 초안 조회
 */
export const getCourseDraftById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCourseDraftById200>(
      {url: `https://api.ugot.uk/api/courses/drafts/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCourseDraftByIdQueryKey = (id: string,) => {
    return [`https://api.ugot.uk/api/courses/drafts/${id}`] as const;
    }

    
export const getGetCourseDraftByIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDraftById>>, TError = GetCourseDraftById401 | GetCourseDraftById403 | GetCourseDraftById404>(id: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDraftByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDraftById>>> = ({ signal }) => getCourseDraftById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDraftByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDraftById>>>
export type GetCourseDraftByIdInfiniteQueryError = GetCourseDraftById401 | GetCourseDraftById403 | GetCourseDraftById404

/**
 * @summary 특정 코스 초안 조회
 */
export const useGetCourseDraftByIdInfinite = <TData = Awaited<ReturnType<typeof getCourseDraftById>>, TError = GetCourseDraftById401 | GetCourseDraftById403 | GetCourseDraftById404>(
 id: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDraftByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCourseDraftByIdQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDraftById>>, TError = GetCourseDraftById401 | GetCourseDraftById403 | GetCourseDraftById404>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDraftByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDraftById>>> = ({ signal }) => getCourseDraftById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDraftByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDraftById>>>
export type GetCourseDraftByIdQueryError = GetCourseDraftById401 | GetCourseDraftById403 | GetCourseDraftById404

/**
 * @summary 특정 코스 초안 조회
 */
export const useGetCourseDraftById = <TData = Awaited<ReturnType<typeof getCourseDraftById>>, TError = GetCourseDraftById401 | GetCourseDraftById403 | GetCourseDraftById404>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDraftByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 코스 초안의 정보를 업데이트합니다.
자신이 작성한 초안만 수정할 수 있습니다.

 * @summary 코스 초안 업데이트
 */
export const updateCourseDraft = (
    id: string,
    updateCourseDraftBody: UpdateCourseDraftBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      const formData = new FormData();
if(updateCourseDraftBody.data !== undefined) {
 formData.append('data', updateCourseDraftBody.data)
 }
if(updateCourseDraftBody.thumbnail !== undefined) {
 formData.append('thumbnail', updateCourseDraftBody.thumbnail)
 }

      return customInstance<UpdateCourseDraft200>(
      {url: `https://api.ugot.uk/api/courses/drafts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getUpdateCourseDraftMutationOptions = <TError = UpdateCourseDraft400 | UpdateCourseDraft401 | UpdateCourseDraft403 | UpdateCourseDraft404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCourseDraft>>, TError,{id: string;data: UpdateCourseDraftBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCourseDraft>>, TError,{id: string;data: UpdateCourseDraftBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCourseDraft>>, {id: string;data: UpdateCourseDraftBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCourseDraft(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCourseDraftMutationResult = NonNullable<Awaited<ReturnType<typeof updateCourseDraft>>>
    export type UpdateCourseDraftMutationBody = UpdateCourseDraftBody
    export type UpdateCourseDraftMutationError = UpdateCourseDraft400 | UpdateCourseDraft401 | UpdateCourseDraft403 | UpdateCourseDraft404

    /**
 * @summary 코스 초안 업데이트
 */
export const useUpdateCourseDraft = <TError = UpdateCourseDraft400 | UpdateCourseDraft401 | UpdateCourseDraft403 | UpdateCourseDraft404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCourseDraft>>, TError,{id: string;data: UpdateCourseDraftBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateCourseDraft>>,
        TError,
        {id: string;data: UpdateCourseDraftBody},
        TContext
      > => {

      const mutationOptions = getUpdateCourseDraftMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 주어진 코스 초안 ID에 연결된 자료(파일) 목록을 페이지네이션하여 조회합니다.
 * @summary 코스 초안 자료 목록 조회
 */
export const getCourseDraftAssets = (
    id: string,
    params?: GetCourseDraftAssetsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCourseDraftAssets200>(
      {url: `https://api.ugot.uk/api/courses/drafts/${id}/assets`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCourseDraftAssetsQueryKey = (id: string,
    params?: GetCourseDraftAssetsParams,) => {
    return [`https://api.ugot.uk/api/courses/drafts/${id}/assets`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCourseDraftAssetsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDraftAssets>>, TError = GetCourseDraftAssets401 | GetCourseDraftAssets403 | GetCourseDraftAssets404 | GetCourseDraftAssets413 | GetCourseDraftAssets415>(id: string,
    params?: GetCourseDraftAssetsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftAssets>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDraftAssetsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDraftAssets>>> = ({ signal }) => getCourseDraftAssets(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftAssets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDraftAssetsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDraftAssets>>>
export type GetCourseDraftAssetsInfiniteQueryError = GetCourseDraftAssets401 | GetCourseDraftAssets403 | GetCourseDraftAssets404 | GetCourseDraftAssets413 | GetCourseDraftAssets415

/**
 * @summary 코스 초안 자료 목록 조회
 */
export const useGetCourseDraftAssetsInfinite = <TData = Awaited<ReturnType<typeof getCourseDraftAssets>>, TError = GetCourseDraftAssets401 | GetCourseDraftAssets403 | GetCourseDraftAssets404 | GetCourseDraftAssets413 | GetCourseDraftAssets415>(
 id: string,
    params?: GetCourseDraftAssetsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftAssets>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDraftAssetsInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCourseDraftAssetsQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDraftAssets>>, TError = GetCourseDraftAssets401 | GetCourseDraftAssets403 | GetCourseDraftAssets404 | GetCourseDraftAssets413 | GetCourseDraftAssets415>(id: string,
    params?: GetCourseDraftAssetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftAssets>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDraftAssetsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDraftAssets>>> = ({ signal }) => getCourseDraftAssets(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftAssets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDraftAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDraftAssets>>>
export type GetCourseDraftAssetsQueryError = GetCourseDraftAssets401 | GetCourseDraftAssets403 | GetCourseDraftAssets404 | GetCourseDraftAssets413 | GetCourseDraftAssets415

/**
 * @summary 코스 초안 자료 목록 조회
 */
export const useGetCourseDraftAssets = <TData = Awaited<ReturnType<typeof getCourseDraftAssets>>, TError = GetCourseDraftAssets401 | GetCourseDraftAssets403 | GetCourseDraftAssets404 | GetCourseDraftAssets413 | GetCourseDraftAssets415>(
 id: string,
    params?: GetCourseDraftAssetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftAssets>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDraftAssetsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 코스 초안을 삭제합니다.
자신이 작성한 초안만 삭제할 수 있습니다.

 * @summary 코스 초안 삭제
 */
export const deleteCourseDraft = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/courses/drafts/${id}/assets`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCourseDraftMutationOptions = <TError = DeleteCourseDraft401 | DeleteCourseDraft403 | DeleteCourseDraft404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourseDraft>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCourseDraft>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCourseDraft>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCourseDraft(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCourseDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCourseDraft>>>
    
    export type DeleteCourseDraftMutationError = DeleteCourseDraft401 | DeleteCourseDraft403 | DeleteCourseDraft404

    /**
 * @summary 코스 초안 삭제
 */
export const useDeleteCourseDraft = <TError = DeleteCourseDraft401 | DeleteCourseDraft403 | DeleteCourseDraft404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourseDraft>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCourseDraft>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCourseDraftMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정 강사의 코스 초안 개수를 조회합니다.
instructorId가 제공되지 않으면 현재 로그인한 사용자의 개수를 반환합니다.

 * @summary 코스 초안 개수 조회
 */
export const getCourseDraftCount = (
    params?: GetCourseDraftCountParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCourseDraftCount200>(
      {url: `https://api.ugot.uk/api/courses/drafts/count`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCourseDraftCountQueryKey = (params?: GetCourseDraftCountParams,) => {
    return [`https://api.ugot.uk/api/courses/drafts/count`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCourseDraftCountInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDraftCount>>, TError = GetCourseDraftCount401 | GetCourseDraftCount403>(params?: GetCourseDraftCountParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftCount>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDraftCountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDraftCount>>> = ({ signal }) => getCourseDraftCount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDraftCountInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDraftCount>>>
export type GetCourseDraftCountInfiniteQueryError = GetCourseDraftCount401 | GetCourseDraftCount403

/**
 * @summary 코스 초안 개수 조회
 */
export const useGetCourseDraftCountInfinite = <TData = Awaited<ReturnType<typeof getCourseDraftCount>>, TError = GetCourseDraftCount401 | GetCourseDraftCount403>(
 params?: GetCourseDraftCountParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftCount>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDraftCountInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCourseDraftCountQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDraftCount>>, TError = GetCourseDraftCount401 | GetCourseDraftCount403>(params?: GetCourseDraftCountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftCount>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDraftCountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDraftCount>>> = ({ signal }) => getCourseDraftCount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDraftCountQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDraftCount>>>
export type GetCourseDraftCountQueryError = GetCourseDraftCount401 | GetCourseDraftCount403

/**
 * @summary 코스 초안 개수 조회
 */
export const useGetCourseDraftCount = <TData = Awaited<ReturnType<typeof getCourseDraftCount>>, TError = GetCourseDraftCount401 | GetCourseDraftCount403>(
 params?: GetCourseDraftCountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftCount>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDraftCountQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 코스 초안을 게시하여 실제 코스로 만듭니다.
자신이 작성한 초안만 게시할 수 있습니다.

 * @summary 코스 초안 게시
 */
export const publishCourseDraft = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PublishCourseDraft200>(
      {url: `https://api.ugot.uk/api/courses/drafts/${id}/publish`, method: 'POST'
    },
      options);
    }
  


export const getPublishCourseDraftMutationOptions = <TError = PublishCourseDraft401 | PublishCourseDraft403 | PublishCourseDraft404 | PublishCourseDraft409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishCourseDraft>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof publishCourseDraft>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishCourseDraft>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  publishCourseDraft(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PublishCourseDraftMutationResult = NonNullable<Awaited<ReturnType<typeof publishCourseDraft>>>
    
    export type PublishCourseDraftMutationError = PublishCourseDraft401 | PublishCourseDraft403 | PublishCourseDraft404 | PublishCourseDraft409

    /**
 * @summary 코스 초안 게시
 */
export const usePublishCourseDraft = <TError = PublishCourseDraft401 | PublishCourseDraft403 | PublishCourseDraft404 | PublishCourseDraft409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishCourseDraft>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof publishCourseDraft>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPublishCourseDraftMutationOptions(options);

      return useMutation(mutationOptions);
    }
    